import React, { useState, useEffect } from "react";
import Select from "react-select";
import { Button } from "react-bootstrap";
import {
  createTicker,
  createTickerPage,
  deleteTickerPage,
  getAllPages,
  getAllTicker,
  getAllTickerPage,
  publishTicker,
  requestPublish,
  unpublishTicker,
} from "../../api/api";
import toastr from "toastr";
import "toastr/build/toastr.min.css";
import { NecStore } from "../../store/necStore";
import { UserLang, UserStore } from "../../store/userStore";
import ToolTip from "../tooltip/tooltip";
import Loader from "../loader/loader";
const TickersPage = (props) => {
  const [vcms, setvcms] = useState([]);
  const [menuname, setMenu] = useState([]);
  const [allPage, setallPage] = useState([]);
  const [allTick, setallTick] = useState([]);
  const [hold, setHold] = useState([]);
  const user = UserStore.useState((s) => s.user);
  const role = NecStore.useState((s) => s.setting);
  const lan = UserLang.useState((s) => s.lan);
  const [loading, setLoading] = useState(true);
  /*   const [modalShow, setModalShow] = useState(false);
  const [allImage,setallImage] = useState([]);
  const [pageModalShow, setPageModalShow] = useState(false);
  */
  const [final, setFinal] = useState([]);
  const newTicker = async (event) => {
    event.preventDefault();
    const page = {
      referenceName: "UnNamed Ticker",
      items: [],
      devices: [],
      draftStatus: true,
      publishStatus: false,
    };
    /* eslint-disable no-unused-vars */
    const result = await createTicker(page).then(
      (result) => {
        toastr.success("Successfully Created New Ticker", "Success");
        let push_url = "/ticker/" + result.data._id;

        props.history.push(push_url);
      },
      (error) => {
        toastr.error("Unable to Create New Ticker", "Error");
      }
    );
    /* eslint-disable no-unused-vars */
  };
  useEffect(() => {
    const getPaged = async () => {
      try {
        const appl = await getAllPages(200, 0);

        const pages = appl.data.pages;
        const imageCount = appl.data.count;

        const opt = pages.map((item) => ({
          value: item._id,
          label: item.referenceName,
        }));
        setallPage(opt);
        setLoading(false);
      } catch (error) {}
    };
    const getTicker = async () => {
      try {
        const appl = await getAllTicker(200, 0);

        const pages = appl.data.tickers;
        const imageCount = appl.data.count;

        const opt = pages.map((item) => ({
          value: item._id,
          label: item.referenceName,
        }));
        setallTick(opt);
        setLoading(false);
      } catch (error) {}
    };
    const tickDetail = async () => {
      /* eslint-disable no-unused-vars */
      const result = await getAllTickerPage(20, 0).then(
        (result) => {
          setFinal(result.data.tickers);
          setLoading(false);
        },
        (error) => {
          toastr.error("Unable to Load Data", "Error");
        }
      );
      /* eslint-disable no-unused-vars */
    };
    getPaged();
    getTicker();
    tickDetail();
  }, [hold]);

  const setNotifications = async (editing) => {
    // setLoading(true);
    /* eslint-disable no-unused-vars */
    // const pageid = props.match.params.id;
    const result = await requestPublish(editing).then(
      (result) => {
        toastr.success("Request Sent", "Success");

        // brandImage(result.data);
        // setPage(result.data);
        // setLoading(false);
      },
      (error) => {
        toastr.error("Unable to Load Data", "Error");
        // setLoading(false);
      }
    );
    /* eslint-disable no-unused-vars */
  };

  const handlePublishRequest = (evt) => {
    evt.preventDefault();

    const opt = {
      itemtype: null,
      itemid: null,
      redirect: "ticker",
      message: "Content Editor requested to Publish Ticker",
    };

    setNotifications(opt);
  };

  const handleUnpublishRequest = (evt) => {
    evt.preventDefault();

    const opt = {
      itemtype: null,
      itemid: null,
      redirect: "ticker",
      message: "Content Editor requested to Unpublish Ticker",
    };

    setNotifications(opt);
  };

  const vcmsChange = (value) => {
    setvcms(value);
  };
  const tickChange = (value) => {
    setMenu(value);
  };
  const handleSave = async (evt) => {
    const obj = { page: menuname.value, ticker: vcms.value };
    /* eslint-disable no-unused-vars */
    if (obj.page !== null && obj.ticker != null) {
      const result = await createTickerPage(obj).then(
        (result) => {
          toastr.success("Successfully Added", "Success");
          window.location.reload(false);
        },
        (error) => {
          toastr.error("UnKnown Error", "Error");
        }
      );
    } else {
      toastr.error("No Page Selected", "Error");
    }
  };
  const handleDelete = async (event, index, id) => {
    const removeId = index;
    event.preventDefault();
    const items = Array.from(final);
    items.splice(removeId, 1);
    setFinal(items);
    if (id !== undefined && id !== "") {
      try {
        /* eslint-disable no-unused-vars */
        const result = await deleteTickerPage(id);
        /* eslint-disable no-unused-vars */
        toastr.success("Successfully Deleted", "Success");
      } catch (error) {
        toastr.error("Error in deleting the Image", "Error");
      }
    } else {
      toastr.error("Delete Id is Missing", "Error");
    }
  };
  const publish = async (event, pageid, ticker) => {
    // setDisable(true);
    // setLoading(true);
    event.preventDefault();

    // const pageid = props.match.params.id;
    /* eslint-disable no-unused-vars */
    const result = await publishTicker(pageid, ticker).then(
      (result) => {
        setHold(result.data);

        toastr.success("Successfully Published", "Success");
        // setLoading(false);
      },
      (error) => {
        toastr.error(error.response.data.error.message, "Error");
        // setLoading(false);
      }
    );
    /* eslint-disable no-unused-vars */
  };
  const unpublish = async (event, pageid, ticker) => {
    // setDisable(true);
    // setLoading(true);
    event.preventDefault();

    // const pageid = props.match.params.id;
    /* eslint-disable no-unused-vars */
    const result = await unpublishTicker(pageid, ticker).then(
      (result) => {
        setHold(result.data);

        toastr.success("Successfully Unpublished", "Success");
        // setLoading(false);
      },
      (error) => {
        toastr.error(error.response.data.error.message, "Error");
        // setLoading(false);
      }
    );
    /* eslint-disable no-unused-vars */
  };

  if (loading) {
    return (
      <div className="content">
        <Loader />
      </div>
    );
  } else {
    return (
      <section className="content">
        <div className="container-fluid">
          <div className="row">
            <div className="col-sm-12">
              <div className="card">
                <div className="card-header">
                  <h3
                    className={
                      lan === "rtl"
                        ? "card-title float-right"
                        : "card-title float-left"
                    }
                  >
                    Add Ticker
                  </h3>
                  <Button
                    variant="light"
                    onClick={(event) => newTicker(event)}
                    style={
                      lan === "rtl"
                        ? {
                            width: "100px",
                            marginTop: "8px",
                            height: "40px",
                            float: "left",
                          }
                        : {
                            width: "100px",
                            marginTop: "8px",
                            height: "40px",
                            float: "right",
                          }
                    }
                  >
                    New
                  </Button>
                </div>
                {/* /.card-header */}
                <div className="card-body">
                  <div className="row">
                    <div className="col-sm-12">
                      <div className="form-group">
                        <div className="row">
                          {lan === "rtl" && (
                            <div className="col-md-4">
                              <div className="form-group">
                                <button
                                  type="button"
                                  className="btn btn-primary float-right"
                                  style={{ width: "100px", marginRight: "6px" }}
                                  onClick={handleSave}
                                  disabled={
                                    !(menuname.length === 0)
                                      ? !(vcms.length === 0)
                                        ? false
                                        : true
                                      : true
                                  }
                                >
                                  Save
                                </button>
                              </div>
                            </div>
                          )}
                          <div className="col-md-4">
                            <div className="form-group">
                              <label
                                className={
                                  lan === "rtl" ? "float-right" : "float-left"
                                }
                              >
                                {lan === "rtl" && (
                                  <ToolTip
                                    info={
                                      "Select required pages available on the ticker"
                                    }
                                    place={lan === "rtl" ? "left" : "right"}
                                  />
                                )}
                                &nbsp;Ticker Page *&nbsp;
                                {!(lan === "rtl") && (
                                  <ToolTip
                                    info={
                                      "Select required pages available on the ticker"
                                    }
                                    place={lan === "rtl" ? "left" : "right"}
                                  />
                                )}
                              </label>
                              <Select
                                name="Tickername"
                                className={
                                  lan === "rtl"
                                    ? "form-control inside-select float-right"
                                    : "form-control inside-select float-left"
                                }
                                options={allTick}
                                onChange={vcmsChange}
                              ></Select>
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="form-group">
                              <label
                                className={
                                  lan === "rtl" ? "float-right" : "float-left"
                                }
                              >
                                {lan === "rtl" && (
                                  <ToolTip
                                    info={
                                      "Select required pages to show ticker"
                                    }
                                    place={lan === "rtl" ? "left" : "right"}
                                  />
                                )}
                                &nbsp;Page to Show Ticker *&nbsp;
                                {!(lan === "rtl") && (
                                  <ToolTip
                                    info={
                                      "Select required pages to show ticker"
                                    }
                                    place={lan === "rtl" ? "left" : "right"}
                                  />
                                )}
                              </label>
                              <Select
                                name="pagename"
                                className={
                                  lan === "rtl"
                                    ? "form-control inside-select float-right"
                                    : "form-control inside-select float-left"
                                }
                                options={allPage}
                                onChange={tickChange}
                              ></Select>
                            </div>
                          </div>
                          {!(lan === "rtl") && (
                            <div className="col-md-4">
                              <div className="form-group">
                                <button
                                  type="button"
                                  className="btn btn-primary"
                                  style={{ width: "100px", marginRight: "6px" }}
                                  onClick={handleSave}
                                  disabled={
                                    !(menuname.length === 0)
                                      ? !(vcms.length === 0)
                                        ? false
                                        : true
                                      : true
                                  }
                                >
                                  Save
                                </button>
                              </div>
                            </div>
                          )}
                        </div>
                        <div className="row" style={{ marginTop: "10px" }}>
                          <div className="col-sm-12">
                            <table
                              id="appadmin"
                              dir={lan === "rtl" ? "rtl" : "ltr"}
                              className="table table-bordered table-hover dataTable dtr-inline"
                              role="grid"
                              aria-describedby="example2_info"
                            >
                              <thead>
                                <tr role="row">
                                  <th
                                    className="sorting_asc"
                                    tabIndex={0}
                                    aria-controls="example2"
                                    rowSpan={1}
                                    colSpan={1}
                                  >
                                    <label
                                      className={
                                        lan === "rtl"
                                          ? "float-right"
                                          : "float-left"
                                      }
                                    >
                                      Selected ticker
                                    </label>
                                  </th>
                                  <th
                                    className="sorting"
                                    tabIndex={0}
                                    aria-controls="example2"
                                    rowSpan={1}
                                    colSpan={1}
                                  >
                                    <label
                                      className={
                                        lan === "rtl"
                                          ? "float-right"
                                          : "float-left"
                                      }
                                    >
                                      {" "}
                                      Page to Show Ticker
                                    </label>
                                  </th>
                                  <th
                                    className="sorting"
                                    tabIndex={0}
                                    aria-controls="example2"
                                    rowSpan={1}
                                    colSpan={1}
                                  >
                                    <label
                                      className={
                                        lan === "rtl"
                                          ? "float-right"
                                          : "float-left"
                                      }
                                    >
                                      Publish
                                    </label>
                                  </th>
                                  <th
                                    className="sorting"
                                    tabIndex={0}
                                    aria-controls="example2"
                                    rowSpan={1}
                                    colSpan={1}
                                  >
                                    <label
                                      className={
                                        lan === "rtl"
                                          ? "float-right"
                                          : "float-left"
                                      }
                                    >
                                      Delete
                                    </label>
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                {final.map((person, index) => (
                                  <tr key={index} role="row" className="even">
                                    <td
                                      className="dtr-control sorting_1"
                                      tabIndex={0}
                                    >
                                      <a
                                        href={"/ticker/" + person.ticker._id}
                                        className={
                                          lan === "rtl"
                                            ? "float-right"
                                            : "float-left"
                                        }
                                      >
                                        {person.ticker.referenceName}
                                      </a>
                                    </td>
                                    <td>
                                      <a
                                        href={
                                          "/" +
                                          person.page.pageType +
                                          "/" +
                                          person.page._id
                                        }
                                        className={
                                          lan === "rtl"
                                            ? "float-right"
                                            : "float-left"
                                        }
                                      >
                                        {person.page.referenceName}
                                      </a>
                                    </td>
                                    <td>
                                      {" "}
                                      {person.draftStatus === true &&
                                        person.publishStatus === false && (
                                          <>
                                            {role.RFP === true &&
                                            user.editor === true ? (
                                              <button
                                                type="#!"
                                                onClick={handlePublishRequest}
                                                className={
                                                  lan === "rtl"
                                                    ? "float-right btn btn-success"
                                                    : "float-left btn btn-success"
                                                }
                                                style={{
                                                  width: "100px",
                                                  marginRight: "6px",
                                                }}
                                                disabled={
                                                  !role.production === true
                                                    ? true
                                                    : false
                                                }
                                                hidden={
                                                  !role.production === true
                                                    ? true
                                                    : false
                                                }
                                              >
                                                Request to Publish
                                              </button>
                                            ) : (
                                              <button
                                                type="#!"
                                                onClick={(event) =>
                                                  publish(
                                                    event,
                                                    person.page._id,
                                                    person.ticker._id
                                                  )
                                                }
                                                className={
                                                  lan === "rtl"
                                                    ? "float-right btn btn-success"
                                                    : "float-left btn btn-success"
                                                }
                                                style={{
                                                  width: "100px",
                                                  marginRight: "6px",
                                                }}
                                                disabled={
                                                  !role.production === true
                                                    ? true
                                                    : false
                                                }
                                                hidden={
                                                  !role.production === true
                                                    ? true
                                                    : false
                                                }
                                              >
                                                Publish
                                              </button>
                                            )}
                                          </>
                                        )}
                                      {person.draftStatus === true &&
                                        person.publishStatus === true && (
                                          <>
                                            {role.RFP === true &&
                                            user.editor === true ? (
                                              <button
                                                type="#!"
                                                onClick={handleUnpublishRequest}
                                                className={
                                                  lan === "rtl"
                                                    ? "float-right btn btn-light"
                                                    : "float-left btn btn-light"
                                                }
                                                style={{
                                                  width: "100px",
                                                  marginRight: "6px",
                                                }}
                                              >
                                                Request to Unpublish
                                              </button>
                                            ) : (
                                              <button
                                                type="#!"
                                                onClick={(event) =>
                                                  unpublish(
                                                    event,
                                                    person.page._id,
                                                    person.ticker._id
                                                  )
                                                }
                                                className={
                                                  lan === "rtl"
                                                    ? "float-right btn btn-light"
                                                    : "float-left btn btn-light"
                                                }
                                                style={{
                                                  width: "100px",
                                                  marginRight: "6px",
                                                }}
                                              >
                                                Unpublish
                                              </button>
                                            )}
                                          </>
                                        )}
                                    </td>
                                    <td>
                                      <button
                                        type="button"
                                        className={
                                          lan === "rtl"
                                            ? "float-right btn btn-light"
                                            : "float-left btn btn-light"
                                        }
                                        onClick={(event) =>
                                          handleDelete(event, index, person._id)
                                        }
                                        disabled={
                                          person.publishStatus === false
                                            ? false
                                            : true
                                        }
                                      >
                                        <i className="fa fa-trash"></i> Delete
                                      </button>
                                    </td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* /.card-body */}
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
};
export default TickersPage;
